import * as React from 'react'

import { breakpoints } from './breakpoints'

type KeyBreakpoint = keyof typeof breakpoints

const findBreakPoint = (width: number) => {
  if (width < breakpoints.phone) {
    return 'phone'
  } else if (width > breakpoints.big) {
    return 'big'
  } else {
    const keys = Object.keys(breakpoints) as KeyBreakpoint[]
    const currentKey = keys.find((b, i) => i > 0 && breakpoints[keys[i - 1]] < width && breakpoints[keys[i]] > width)

    return currentKey || 'phone'
  }
}

const useBreakpoint = () => {
  const [windowSize, setWindowSize] = React.useState({ height: window.innerHeight, width: window.innerWidth })
  const [currentBreakpoint, setCurrentBreakpoint] = React.useState<KeyBreakpoint>(findBreakPoint(windowSize.width))

  const onSizeChange: EventListener = () => {
    setWindowSize({ height: window.innerHeight, width: window.innerWidth })
  }

  React.useEffect(() => {
    setWindowSize({ height: window.innerHeight, width: window.innerWidth })
    window.addEventListener('resize', onSizeChange)

    return () => window.removeEventListener('resize', onSizeChange)
  }, [])

  React.useEffect(() => {
    const next = findBreakPoint(windowSize.width)
    setCurrentBreakpoint(next)
  }, [windowSize.width])

  return [windowSize, currentBreakpoint, breakpoints] as const
}
export default useBreakpoint
